module.exports = __webpack_public_path__ + "img/سه-لت.d283f9f7.png";